import React, { useEffect, useState } from 'react';
import { X, CookingPot } from '@phosphor-icons/react';

export const CookPhotoModal = ({ dish, apiBase, onClose }) => {
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    setDetail(null);
    setLoading(true);
    (async () => {
      try {
        const r = await fetch(`${apiBase}/api/public/dishes/${dish.dish_key}?lang=hi`);
        if (r.ok) {
          const j = await r.json();
          if (live) setDetail(j);
        }
      } catch (_) {}
      if (live) setLoading(false);
    })();
    return () => { live = false; };
  }, [dish.dish_key, apiBase]);

  const hero = detail?.hero_image_url || dish.image_url;
  const steps = detail?.step_images || [];
  const instructions = detail?.instructions || [];

  return (
    <div className="fixed inset-0 z-[100] bg-black overflow-y-auto" data-testid="cook-photo-modal">
      {/* Header */}
      <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 bg-black backdrop-blur-md border-b border-white/10">
        <div>
          <h2 className="text-2xl sm:text-3xl font-bold text-white">{detail?.name || dish.name}</h2>
          {detail?.name && detail.name !== dish.name && (
            <p className="text-sm text-neutral-500">{detail?.name_en || dish.name}</p>
          )}
        </div>
        <button onClick={onClose} data-testid="cook-photo-close"
          className="w-14 h-14 rounded-2xl bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0 transition-colors">
          <X size={30} className="text-white" />
        </button>
      </div>

      <div className="px-4 sm:px-8 py-5 max-w-4xl mx-auto space-y-6 pb-16">
        {/* Hero photo */}
        {hero ? (
          <img src={`${apiBase}${hero}`} alt={dish.name} data-testid="cook-photo-hero"
            className="w-full max-h-[62vh] object-cover rounded-3xl border border-white/10" />
        ) : (
          <div className="w-full h-64 rounded-3xl bg-white/5 border border-white/10 flex flex-col items-center justify-center gap-3">
            <CookingPot size={56} className="text-neutral-600" />
            <p className="text-neutral-500 text-lg">फ़ोटो अभी तैयार नहीं है</p>
          </div>
        )}

        {loading && (
          <p className="text-center text-neutral-500 text-lg animate-pulse" data-testid="cook-photo-loading">विधि लोड हो रही है…</p>
        )}

        {/* Step pictures */}
        {steps.length > 0 && (
          <div className="space-y-5" data-testid="cook-photo-steps">
            <p className="text-sm font-bold text-neutral-400 uppercase tracking-wider">बनाने की विधि — तस्वीरों में</p>
            {steps.map((s, i) => (
              <div key={i} className="rounded-3xl overflow-hidden border border-white/10 bg-white/[0.03]" data-testid={`cook-photo-step-${s.index || i + 1}`}>
                <img src={`${apiBase}/api/meals/dish-steps/${dish.dish_key}_step${s.index || i + 1}.jpg`}
                  alt={`Step ${s.index || i + 1}`} className="w-full max-h-[55vh] object-cover" loading="lazy" />
                <div className="flex items-start gap-3 px-5 py-4">
                  <span className="w-9 h-9 rounded-xl bg-[#FF6B35]/15 text-[#FF6B35] flex items-center justify-center flex-shrink-0 text-base font-bold">
                    {s.index || i + 1}
                  </span>
                  <p className="text-lg text-neutral-200 leading-relaxed pt-1">
                    {instructions[(s.index || i + 1) - 1] || s.step}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Text-only instructions fallback when no step photos exist */}
        {!loading && steps.length === 0 && instructions.length > 0 && (
          <div className="space-y-3" data-testid="cook-photo-instructions">
            <p className="text-sm font-bold text-neutral-400 uppercase tracking-wider">बनाने की विधि</p>
            {instructions.map((step, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="w-9 h-9 rounded-xl bg-[#FF6B35]/15 text-[#FF6B35] flex items-center justify-center flex-shrink-0 text-base font-bold">{i + 1}</span>
                <p className="text-lg text-neutral-200 leading-relaxed pt-1">{step}</p>
              </div>
            ))}
          </div>
        )}

        {!loading && !detail && (
          <p className="text-center text-neutral-500 text-base" data-testid="cook-photo-no-detail">
            विस्तृत विधि उपलब्ध नहीं है — ऐप में एक बार रेसिपी खोलने पर यहाँ तस्वीरें आ जाएँगी।
          </p>
        )}
      </div>
    </div>
  );
};
